module.exports = __webpack_public_path__ + "static/img/15037C_1_2_R_20221217_LC.fcc40ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/15037C_1_2_R_20221217_LC.png
// module id = kyIY
// module chunks = 0